import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Content from './Content';

const useStyles = makeStyles((theme) => ({
  
}));

function E911Setup(props) {
  const classes = useStyles();

  return (
    <Content>
      <h1>E911Setup</h1>
    </Content>
  );
}

export default E911Setup;
